import MathRenderer from "../components/taskUser copy 3.js"
import React, { Component } from 'react';
import Markdownkatexnew from "./Markdown.js";
import Navigation from '../screens/Navigation.jsx';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
import { Link } from 'react-router-dom';
import axios from 'axios'
import WindowFocusHandler from "./isvisible.js";
import Select, { components } from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Blog from "../components/taskUser copy 2.js";
import Socket from "../screens/Chat.jsx";
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, Toolbar } from 'ckeditor5';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Math from 'ckeditor5-math/src/math';
// import TimeAgo from 'timeago-react';
import Timer from './timer.js';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import 'katex/dist/katex.min.css'; // Don't forget the KaTeX stylesheet
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
import { isAuth } from "../helpers/auth.js";
registerLocale('es', wes);
timeago.register('es', es);

export default class Tests extends Component {

  constructor(props) {
    super(props);
    this.state = {
      solution: "",
      contenido: "",
      task: "",
      detalle: "",
      detail: `
Entonces \\(\\alpha\\) es el límite inferior de la integral definida: 
\\[\\int_\\alpha^\\beta f(x) \\,dx\\]

\\subsection*{Propiedades fundamentales}
A partir de este análisis, se pueden estudiar las propiedades de las raíces (fórmulas de Vieta):

    La suma de las raíces: \\(\\alpha + \\beta = -\\frac{b}{a}\\)
    El producto de las raíces: \\(\\alpha \\cdot \\beta = \\frac{c}{a}\\)
`,
      // detail: '<p>www www</p><p><span class="math-tex">\\(www\\)</span></p>',
      themeall: "",
      fechaexa: new Date(),
      timexa: "2",
      editing: false,
      integers: [],
      items: [],
      itemsnew: [],
      itemsnewnew: [],
      theme: "",
      dateb: new Date(),
      datee: "",
      note: "",
      setLoading: false,
      one: 3,
      noww: "",
      _idcurse: "",
      submit: "",
    }
  };

  getNotes = async () => {
    // console.log(this.props.match.params.idtest)
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      console.log(res.data, "www");
      if (res.data && res.data.length != 0) {
        this.setState({
          dateb: parseISO(res.data.dateb),
          datee: parseISO(res.data.datee),
          theme: res.data,
          idcurse: res.curse,
          items: res.data.items,
          itemsnew: JSON.stringify(res.data.items),
          solution: res.data.solution,
          task: res.data.task == '' ? 'www' : res.data.task.replace(new RegExp('<span class="math-tex">\(\)</span>', 'g'), '').replace(new RegExp('<span class="math-tex">\[\]</span>', 'g'), ''),
          note: res.data.note,
        });
      } else {
        // history.push("/categorias");
      }
    });
  }

  getNotesNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      this.setState({
        theme: res.data[0],
      });
      console.log(res.data[0]);
      console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async (items, note) => {
    console.log(items, note, this.props.match.params.idtest)
    const Data = {
      task: this.state.task,
      solution: this.state.solution,
      items: items,
      note: note
    };
    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`, Data).then(res => {
      toast.dark(res.data)
      // this.getNotes()
    });
  };

  CargarStorage = async () => {
    function isValidJSON(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (error) {
        return false;
      }
    }

    console.log(JSON.stringify(localStorage.getItem("test")))
    console.log(JSON.parse(localStorage.getItem("test")))
    console.log(isValidJSON(localStorage.getItem("test")))
    this.setState({
      itemsnewnew: JSON.parse(localStorage.getItem("test")),
      // items:JSON.parse(localStorage.getItem("test"))
    })
  };

  culminarTest = () => {
    var encuestas = this.state.items
    var rptas = []
    for (var j = 0; j < encuestas.length; j++) {
      if (encuestas[j].alt) {
      } else {
        // this.ollama(encuestas[j].std, encuestas[j].prg, this.props.match.params.idtest)
        // console.log(encuestas[j].std, this.props.match.params.idtest)
      }
    }
  }

  async componentDidMount() {
    await this.getNotes()

    // this.setState({
    //   detalle: this.state.detail.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')
    // })
    // console.log(this.state.detail, this.state.detail.replace(/\\\]/g, '\]<\/span>').replace(/\\\[/g, '<span class="math-tex">'))
  }

  // replace(new RegExp('\\\[', 'g'), '<span class="math-tex">').replace(new RegExp('\]', 'g'), '<\/span>')
  onChange = (text) => (e) => {
    // console.log(e.label[0], e.value[0], text)
    // console.log(e.label[0], text);
    var www = this.state.items
    www[text].std = e.label[0]
    this.setState({
      items: www
    })
    var rptas = []
    for (var j = 0; j < www.length; j++) {
      if (www[j].std === www[j].rpta) {
        rptas.push(1)
      } else {
        rptas.push(0)
      }
    }
    this.setState({ note: rptas.filter(x => x === 1).length })

    console.log(rptas.filter(x => x === 1).length)
    if (www != null) { this.submitTest(www, rptas.filter(x => x === 1).length) }
    // this.submitTest()
  }

  onChangeText = (text, i, obsstd) => {

    function getLevenshteinSimilarity(str1, str2) {
      const track = Array(str2.length + 1).fill(null).map(() =>
        Array(str1.length + 1).fill(null)
      );

      for (let i = 0; i <= str1.length; i += 1) track[0][i] = i;
      for (let j = 0; j <= str2.length; j += 1) track[j][0] = j;

      for (let j = 1; j <= str2.length; j += 1) {
        for (let i = 1; i <= str1.length; i += 1) {
          const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
          track[j][i] = Math.min(
            track[j - 1][i] + 1, // deletion
            track[j][i - 1] + 1, // insertion
            track[j - 1][i - 1] + indicator // substitution
          );
        }
      }

      const distance = track[str2.length][str1.length];
      const maxLength = Math.max(str1.length, str2.length);

      if (maxLength === 0) return 100;
      return ((maxLength - distance) / maxLength) * 100;
    }

    var www = this.state.itemsnewnew
    console.log(text, i, obsstd)

    if (obsstd === 'std') {
      www[i].std = text
    } else {
      www[i].obs = text
    }
    // this.setState({
    //   itemsnewnew: www
    // })
    console.log(getLevenshteinSimilarity(text, www[i].obs))
    if (www != null) { this.submitTest(www, 3*getLevenshteinSimilarity(text, www[i].obs)/100) }
    // this.submitTest()
  }

  onChangeTextsimulacro = (text) => {
    console.log(text)
    // var www = this.state.items
    // www[i].std = text
    this.setState({
      detail: text
    })
    // console.log(www)
    // if (www != null) { this.submitTest(www, this.state.note) }
    // this.submitTest()
  }

  MarkdownOption = (props) => {
    // console.log(props.data.label[0])
    return (
      <components.Option {...props}>
        <MathRenderer>{props.data.label[0]}</MathRenderer>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    // console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <MathRenderer>{props.data.label[0]}</MathRenderer>
      </components.SingleValue>
    );
  };

  ollama = async (prompt, pregunta, idtest) => {
    // e.preventDefault();
    console.log(prompt, idtest)
    // if (!input.trim()) return;

    this.setState({ setLoading: true });
    // setResponse('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/userReduce`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: `Calficar de 0 a 1 la siguiente respuesta ${prompt} a la pregunta ${pregunta}`,
          model: "llama3" //gemma4  Change this to your local model name
        }),
      });

      const data = await res.json();
      if (data.response) {
        console.log(data.response);
      } else {
        console.log('Error: No hay respuesta recibida.');
      }
    } catch (err) {
      console.log('Error al conectar con el backend server.');
    } finally {
      this.setState({ setLoading: false });
    }
  };


  safeJsonParse(str, fallback = null) {
    try {
      return JSON.stringify(str);
    } catch {
      return fallback;
    }
  }

  handleDataFromChild = (data) => {
    // WindowFocusHandler
    // history.push(`/curso/${this.state._idcurse}`)
    console.log(this.state._idcurse)
    this.setState({ setLoading: true });
  };

  handleFromChild = (data) => {
    // setSecondsRemaining(0)
    console.log(data)
    // this.props.history.push(`/curso/${this.props.match.params.theme}`)
    // setShow(false);
  };


  render() {
    return (
      <div className=''>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Navigation />

        {/* <WindowFocusHandler onDataReceived={this.handleDataFromChild} /> */}
        <Timer endDate={this.state.datee} onFinish={this.handleFromChild} />

        <div className='container'>



          {/* <Blog /> */}
          <div>
            <div className='row justify-content-center align-items-center border d-flex' style={{ margin: '.5em' }}>
              {this.state.itemsnewnew ?
                this.state.itemsnewnew.map((number, i) =>
                  <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                    <div className="">
                      [{i + 1}]
                      <MathRenderer>
                        {number.prg}
                      </MathRenderer>
                      <div className="p-1 bg-warning">
                        {number.alt ?
                          <div className='marginbottomp'>
                            <Select onChange={this.onChange(i)} options={
                              number.alt.map((guest, index) => {
                                return {
                                  label: guest,
                                  value: guest,
                                  key: index
                                }
                              })
                            } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                          </div>
                          :
                          <div>
                            <CKEditor editor={ClassicEditor} config={{
                              // plugins: [Math, /* ... other plugins */],
                              language: 'es', placeholder: "Descripción",
                              toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                              math: {
                                engine: 'katex', // or 'mathjax'
                                outputType: 'span', // 'span' or 'script'
                                forceOutputType: false,
                                enablePreview: true
                              }
                            }} data={number.obs.includes("math-tex") ? number.obs : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                              onBlur={(event, editor) => {
                                // console.log(editor.getData(), i, 'obs')
                                this.onChangeText(editor.getData(), i, 'obs')
                              }} onReady={editor => {
                                // console.log('Editor is ready to use!', editor)
                              }}
                            // name="detail"
                            />
                            <CKEditor editor={ClassicEditor} config={{
                              // plugins: [Math, /* ... other plugins */],
                              language: 'es', placeholder: "Descripción",
                              toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                              math: {
                                engine: 'katex', // or 'mathjax'
                                outputType: 'span', // 'span' or 'script'
                                forceOutputType: false,
                                enablePreview: true
                              }
                            }} data={number.std.includes("math-tex") ? number.std : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                              onBlur={(event, editor) => {
                                // console.log(editor.getData(), i, 'obs')
                                this.onChangeText(editor.getData(), i, 'std')
                              }}
                            />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                ) : ''
              }
            </div>
          </div>


          {isAuth().rol == '1' ?
            <div>
              <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                {this.state.items ? this.state.items.map((number, i) =>
                  <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                    <div className="p-1 bg-light rounded">
                      {/* {number.prg} */}
                      [{i + 1}]
                      <MathRenderer>
                        {number.prg}
                      </MathRenderer>
                      {number.alt ?
                        <div className='marginbottomp'>
                          <Select onChange={this.onChange(i)} options={
                            number.alt.map((guest, index) => {
                              return {
                                label: guest,
                                value: guest,
                                key: index
                              }
                            })
                          } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                        </div>
                        :
                        <div>
                          <CKEditor editor={ClassicEditor} config={{
                            // plugins: [Math, /* ... other plugins */],
                            language: 'es', placeholder: "Descripción",
                            toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                            math: {
                              engine: 'katex', // or 'mathjax'
                              outputType: 'span', // 'span' or 'script'
                              forceOutputType: false,
                              enablePreview: true
                            }
                          }} data={number.obs.includes("math-tex") ? number.obs : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                            onBlur={(event, editor) => {
                              this.onChangeText(editor.getData(), i, 'obs')
                            }} onReady={editor => {
                              // console.log('Editor is ready to use!', editor)
                            }}
                          // name="detail"
                          />
                          <CKEditor editor={ClassicEditor} config={{
                            // plugins: [Math, /* ... other plugins */],
                            language: 'es', placeholder: "Descripción",
                            toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                            math: {
                              engine: 'katex', // or 'mathjax'
                              outputType: 'span', // 'span' or 'script'
                              forceOutputType: false,
                              enablePreview: true
                            }
                          }} data={number.std.includes("math-tex") ? number.std : number.std.replace(/\\\]/g, '\\]<\/span>').replace(/\\\[/g, '<span class="math-tex">\\[').replace(/\\\)/g, '\\)<\/span>').replace(/\\\(/g, '<span class="math-tex">\\(')}
                            onChange={(event, editor) => {
                              this.onChangeText(editor.getData(), i, 'std')
                            }}
                          />
                        </div>

                      }
                    </div>
                  </div>
                ) : ''}
              </div>
              <textarea className="form-control" defaultValue={this.state.itemsnew} rows={8} onChange={(event) => {
                // localStorage.setItem("test", event.target.value);
                localStorage.setItem("test", event.target.value);

                console.log(JSON.parse(localStorage.getItem("test")) ? JSON.parse(localStorage.getItem("test")) : 'none')
                // if (JSON.parse(event.target.value)) {
                //   this.setState({
                //     items: JSON.parse(event.target.value)
                //   })
                // }
              }}
                required="required"></textarea>
              {this.state.solution.length < 3 ? <input placeholder='Nota' defaultValue={this.state.note} onChange={(event) => {
                this.setState({
                  note: event.target.value
                });
                console.log(event.target.value)
              }} className="form-control mt-3" /> : null}
            </div>
            : null
          }

          {this.state.dateb < this.state.noww && this.state.noww < this.state.datee || JSON.parse(localStorage.getItem("user")).rol == '1' ?
            <>
              <button className="btn btn-info w-100" onClick={() => { this.submitTest(this.state.items, this.state.note) }} disabled={this.state.setLoading}>
                Guardar
              </button>
              <button className="btn btn-info w-100 my-1" onClick={() => { this.CargarStorage() }} disabled={this.state.setLoading}>
                CargarStorage
              </button>
              <button className="btn btn-info w-100" onClick={() => { this.culminarTest() }} disabled={this.state.setLoading}>
                Culminar y calificar
              </button>
            </>
            :
            <div className="bg-warning w-100 p-1 my-5 text-center">Culminó el tiempo establecido
              <Link
                className="btn btn-outline-info w-100"
                style={{ color: 'dark' }}
                to={'/curso/' + this.state.theme.curse}
              >Ir al curso</Link>
            </div>
          }

        </div>
        <Socket />
      </div >
    );
  }
}
